var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NotFoundContainer"},[_c('h1',[_vm._v(_vm._s(_vm.$store.state.notfoundtext))]),_c('video',{attrs:{"id":"vid","playsinline":"","autoplay":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require("./../assets/404.mp4"),"type":"video/mp4"}}),_vm._v(" Your browser does not support the video tag. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }